export const SEND_EMAIL = "SEND_EMAIL";
export const SEND_EMAIL_SUCCESS = "SEND_EMAIL_SUCCESS";
export const SEND_EMAIL_FAILURE = "SEND_EMAIL_FAILURE";
export const RESET_SEND_EMAIL = "RESET_SEND_EMAIL";

export const SET_EMAIL_OPEN = "IS_EMAIL_OPEN";
export const SET_EMAIL_CLOSE = "IS_EMAIL_CLOSE";
export const GET_EMAIL_ATTACHMENT = "GET_EMAIL_ATTACHMENT";
export const GET_EMAIL_ATTACHMENT_SUCCESS = "GET_EMAIL_ATTACHMENT_SUCCESS";
export const GET_EMAIL_ATTACHMENT_FAILURE = "GET_EMAIL_ATTACHMENT_FAILURE";
